import React, { CSSProperties } from 'react';
import Icon from '../Icon/Icon';

import './Button.scss';
import { ButtonColors } from '../../utilities/enum/buttonColors';

interface Props {
    disabled?: boolean;
    styleClass?: ButtonColors;
    style?: CSSProperties;
    text: string;
    onClick: (event?: any) => void;
    icon?: string;
    iconColor?: string;
    isUppercase?: boolean;
    isSubmit?: boolean;
}

const Button: React.FC<Props> = ({
    disabled = false,
    styleClass = ButtonColors.GRADIENT,
    style = {},
    text,
    onClick,
    icon = '',
    iconColor = '#fff',
    isUppercase,
    isSubmit,
}) => {
    return (
        <button
            type={isSubmit ? 'submit' : 'button'}
            style={{
                ...style,
            }}
            className={`button ${styleClass.includes('link') ? '-link' : ''} -${styleClass} ${
                disabled ? '-disabled' : ''
            } `}
            onClick={(event) => {
                if (!disabled) {
                    onClick(event);
                }
            }}
        >
            {icon ? <Icon name={icon} size={18} color={iconColor} /> : null}
            <span className={isUppercase ? '-uppercase' : ''}>{text}</span>
        </button>
    );
};

export default Button;
